import {Injectable} from '@angular/core';
import {NavigationEnd, Router, RouterModule} from '@angular/router';
import {Location} from '@angular/common';
import {IonRouterOutlet, NavController} from '@ionic/angular';
import {AppService} from './app.service';
import {filter} from 'rxjs/operators';
import {UserModelService} from 'app/models/user-model.service';
import {WorkersModalComponent} from 'app/pages/functions/components/workersModal/item';

@Injectable({
  providedIn: 'root',
})
export class NavigationService {
  router: Router;
  location: Location;
  navController: NavController;
  appService: AppService;
  routerOutlet: IonRouterOutlet;
  userModelService: UserModelService;

  entryUrl: string | null;

  public previousUrl;
  public currentUrl;

  public routeStack = [];

  menuRoutes: any[] = [];

  constructor(
    router: Router,
    location: Location,
    appService: AppService,
    userModelService: UserModelService,
    navController: NavController
  ) {
    this.router = router;
    this.location = location;
    this.navController = navController;
    this.appService = appService;
    this.userModelService = userModelService;

    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.previousUrl = this.currentUrl;
      this.currentUrl = event.url.replace(/^\/+/g, '');
    });

  }

  isCurrentUrl(url) {
    return this.currentUrl === url;
  }

  goTo(url: string, opt = {}, replaceUrl = false) {

    this.pushToStack(this.currentUrl, replaceUrl);

    if (replaceUrl) {
      this.navController.navigateRoot([url], {queryParams: opt, replaceUrl});
    } else {
      this.navController.navigateForward([url], {queryParams: opt, replaceUrl});
    }

    // console.log('forward');
    // console.log(this.routeStack);
  }

  pushToStack(url: string, reset = false) {
    if (reset) {
      this.routeStack = [];
    } else {
      if (typeof url !== 'undefined') {
        this.routeStack.push(url);
      }
    }
  }

  // goToUrl(url: any) {
  //   if (typeof url === 'string' || url instanceof String) {
  //     url = [url];
  //   }
  //
  //   this.router.navigate(url);
  // }

  goBack() {
    this.back();
  }

  goAfterLogin(loggedIn) {
    if (loggedIn) {
      let entryUrl = this.entryUrl ? this.entryUrl : 'dashboard';

      if (this.appService.pushData) {
        if (this.appService.pushData.page) {
          entryUrl = this.appService.pushData.page;
        } else if (this.appService.pushData.data) {

          setTimeout(() => {
            this.processActionDataModal();
          }, 500);

        }
      }

      if (entryUrl.includes('authentication')) {
        entryUrl = 'dashboard';
      }

      this.goTo(entryUrl, {}, true);
    } else {
      this.goTo('authentication/phone', {}, true);
    }
  }

  public back(fullBack = false) {
    if (this.appService.back()) {

      if (this.canGoBackIfNotStartPage()) {
        this.pushToStack(this.currentUrl);
        this.navController.navigateBack('dashboard');
      } else {
        if (fullBack === false && this.canGoBack()) {
          this.navController.navigateBack([this.routeStack.pop()]);
        } else {
          this.navController.navigateBack([this.routeStack[0]]);
          this.routeStack = [];
        }
      }

      // console.log('back');
      // console.log(this.routeStack);

      // if (fullBack === false && this.canGoBack()) {
      //   this.routerOutlet.pop(1);
      // } else if (fullBack) {
      //
      //   for (let i = 1; i <= 10; i++) {
      //     if (this.canGoBack(i) === false) {
      //       this.routerOutlet.pop(i - 1);
      //     }
      //   }
      //
      // }

    }
  }

  canGoBackIfNotStartPage() {
    // uncomment if redirect to dashabord is mandatory
    return !this.isCurrentUrl('dashboard') && this.routeStack.length === 0;
    // return false;
  }

  canGoBack(index = 1) {
    return this.canGoBackIfNotStartPage() ? true : this.routeStack.length !== 0;
  }

  routeActive(path: string) {
    return this.router.isActive(path, false);
  }

  processActionData(data, page = null) {

    this.appService.pushData = {data, page};

    if (page && page === window.location.pathname.replace('/', '')) {
      // eslint-disable-next-line @typescript-eslint/dot-notation
      this.routerOutlet['activated']?.instance?.processPush();
    } else {
      if (this.userModelService.isLogin()) {

        if (page) {
          this.goTo(this.appService.pushData.page);
        } else {
          this.processActionDataModal();
        }

      } else {

        if (page) {
          this.entryUrl = page;
        } else {
          this.entryUrl = 'dashboard';
        }

      }
    }

  }

  processActionDataModal() {
    if (this.appService.pushData?.data?.modal) {
      if (this.appService.pushData?.data?.modal === 'worker-list') {
        console.log('processActionDataModal', this.appService.pushData?.data);
        this.appService.appModalService.openModal(WorkersModalComponent, {inputData: this.appService.pushData?.data.data});
      }
    }

    this.appService.pushData = null;
  }

  getMenuRoutes() {
    const groups: {routes: any[]; caption: string | null; id: string}[] = [
      {id: 'prefix',     caption: null,            routes: []},
      {id: 'activity',   caption: 'Активность',    routes: []},
      {id: 'personal',   caption: 'Личное',        routes: []},
      {id: 'finance',    caption: 'Финансы',       routes: []},
      {id: 'handbooks',  caption: 'Справочники',   routes: []},
    ];
    const groupTypesAllowed = groups.map((item) => item.id);

    let routes = this.router.config.filter(item => {
      const hasPermission: boolean = (
        !item.data?.permission ||
        (
          !!item.data?.permission &&
          this.userModelService.isLogin() &&
          this.userModelService.permissions.checkPermission(item.data?.permission)
        ));

      if (!!item.data?.menuTitle && hasPermission) {

        if (typeof item.data?.menuOrder !== 'number') {
          item.data.menuOrder = 999;
        }

        if (!groupTypesAllowed.includes(item.data?.menuGroup)) {
          item.data.menuGroup = 'prefix';
        }

        return true;
      }
    });
    routes = routes.sort((a, b) => a.data.menuOrder - b.data.menuOrder );

    // console.log('groupTypesAllowed', groupTypesAllowed);
    // console.log('routes', routes);
    // console.log('permissions', this.userModelService.permissions);

    for (const route of routes) {
      groups.find(item => item.id === route.data?.menuGroup).routes.push(route);
    }

    console.log('menuRoutes', groups);
    this.menuRoutes = groups;
  }

}
